export const environment = {
  production: false,
  apiUrl:
    'https://empowerindia-api-dyckeafkc0ebhxft.southeastasia-01.azurewebsites.net/empower_andhra/api/v1',
  version: '0.0.9',
};
